import React from 'react'

import SearchIcon from '@mui/icons-material/Search'
import { Button } from '@mui/material'

interface SearchButtonProps {
  onSearchClick?: () => void
  caption?: string
  searchId?: string
  disabled?: boolean
}

function SearchButton({ caption = '検索', searchId ,onSearchClick, disabled}: SearchButtonProps) {
  return (
    <Button type="submit" id={searchId} variant="contained" startIcon={<SearchIcon />} onClick={onSearchClick} disabled={disabled}>
      {caption}
    </Button>
  )
}

export default SearchButton
